export default __webpack_public_path__ + "static/media/loading.89540200.svg";